export default {
    methods: {
        checkMarkText (status) {
            if (
                [
                    this.statusesId.FAMILY_VERIFIED_AREA_REACH,
                    this.statusesId.GIFT_GIVING_REPORT_AREA_REACH
                ].includes(status)
            ) {
                return this.$t('family_card.document_section.regional_audit_tooltip');
            }
            if (
                [
                    this.statusesId.FAMILY_VERIFIED_NATIONAL_REACH,
                    this.statusesId.GIFT_GIVING_REPORT_NATIONAL_REACH
                ].includes(status)
            ) {
                return this.$t('family_card.document_section.national_audit_tooltip');
            }
        }
    }
};
